// extracted by mini-css-extract-plugin
export default {"info":"Filters_info__PIgar","group":"Filters_group__kW0P7","checkbox":"Filters_checkbox__gWWmJ","btns":"Filters_btns__I-Tff","button":"Filters_button__JTYvT"};